import { Vue, Component } from 'vue-property-decorator';
import { OperationSettingDTO , ExchangeRatio} from '@/models';
import { fetchOperationSettings, saveOperationSettings } from '@/services';


@Component
export default class OperationSetting extends Vue {
  $refs!: {
    formRef: HTMLFormElement;
  };

  private operationSetting = {} as OperationSettingDTO;
  private autoRateDays = 3; // Default value, will be updated from API
  private rewardDropData: Array<{ value: string; ratio: number; rangeStart: number }> = [];

  private tableHeaders = [
    { text: 'Estimated Price', value: 'value' },
    { text: 'Ratio', value: 'ratio' },
    { text: 'Cost per Item', value: 'samplePrice' },
  ];

  private getPriceFormula(ratio: number, rangeStart: number): string {
    const basePrice = rangeStart;
    const calculatedDrops = (basePrice * ratio) / 1000;
    return `Item price ${basePrice} đ = ${basePrice} x ${ratio}(ratio) / 1000 = ${calculatedDrops.toFixed(
      0
    )} pollens`;
  }

  async onSave(): Promise<void> {
    const exchangeRatio: ExchangeRatio = {
      VALUE_RANGE: this.rewardDropData.map((item) => item.rangeStart),
      RATIO: this.rewardDropData.map((item) => item.ratio),
    };

    const payload: OperationSettingDTO = {
      autoRateDays: this.autoRateDays,
      exchangeRatio: JSON.stringify(exchangeRatio),
    };

    try {
      await saveOperationSettings(payload);
    } catch (error) {
      console.error('Failed to save operation settings:', error);
    }
  }

  onCancel(): void {
    location.reload();
  }

  async mounted(): Promise<void> {
    try {
      const payload = await fetchOperationSettings();
      this.autoRateDays = payload.data.autoRateDays; 
      const exchangeRatio = JSON.parse(payload.data.exchangeRatio) as ExchangeRatio;
      this.rewardDropData = exchangeRatio.VALUE_RANGE.map((value, index) => ({
        value: `Up to ${value * 1000} VND`,
        ratio: exchangeRatio.RATIO[index],
        rangeStart: value,
      }));
    } catch (error) {
      console.error('Failed to fetch operation settings:', error);
    }
  }
}